<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                        {{ this.parentObject.pageTitle 
                        }}<span class="page_title_value">{{
                             this.parentObject.pageTitleValue 
                             }}</span>
                             </h2>
                </v-row>

                <v-col class="mt-n4 mb-2"> 
                    <v-row> 
                        <v-btn
                        v-model ="goBtn"
                        @click="backButton()"
                        color="orange"
                        class="white--text"
                        >{{$t('button.back')}}</v-btn>
                    </v-row>
                </v-col>
                
                <v-container
                    id="scroll-target"
                    class="custom-form px-5"
                >

                <v-row>
                    <v-toolbar flat >
                        <v-toolbar-title>
                            {{$t('cashdenominationlistingreport.cashdenominationlistingforyearmonthandpauyoutid')}}
                            <span class="blue--text"> 
                                {{this.data.formData.dateYear}}</span>
                                 {{this.$t('reportsparam.month')}} , <span class="blue--text"> 
                                     {{this.data.formData.dateMonth}}</span> 
                                     {{$t('cashdenominationlistingreport.andpayoutid')}} <span class="blue--text"> 
                                         {{this.data.formData.payoutcode}}</span>
                            <div class="title-1 "> 
                                <span class="blue--text"> 
                                    {{this.data.formData.compnyname}}</span> 
                                    </div>                         
                        </v-toolbar-title>
                            <v-spacer></v-spacer>
                        
                        <div class="export-icon-btns">
                            <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                              PDF
                            </button>
                            <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                              CSV
                            </button>
                          </div>
                                
                    </v-toolbar>
                </v-row>

                <v-row>
                            
                    <v-col >
                        <div class="rpt-table-wrap">
                        <v-data-table
                            hide-default-footer
                            :headers="dataHeader"
                            :items="dataItems"
                            :items-per-page="1000"
                            multi-sort
                           :no-data-text="this.$t('vdatatable.norecordsfound')"
                        >
                        
                        <template v-slot:body>
                            <tbody>
                                <tr v-for="item in dataItems" :key="item">
                                    <td >
                                        {{item.salhdid}}
                                    </td>
                                    <td >
                                        {{item.compnycode}}
                                    </td>

                                    <td >
                                        {{item.psnname}}
                                    </td>

                                    <td >
                                        {{item.staffcode}}
                                    </td>
                                
                                    <td >
                                        <v-layout justify-end>{{item.amount}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm100}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm50}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm20}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm10}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm5}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.rm1}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.sen50}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.sen20}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.sen10}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.sen5}}</v-layout>
                                    </td>

                                    <td >
                                        <v-layout justify-center>{{item.sen1}}</v-layout>
                                    </td>
                                </tr>
                                <tr class="total">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><v-layout justify-end>{{total}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm100}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm50}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm20}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm10}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm5}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountRm1}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountSen50}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountSen20}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountSen10}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountSen5}}</v-layout></td>
                                    <td><v-layout justify-center>{{totalCountSen1}}</v-layout></td>
                                </tr>

                            </tbody>
                        </template>
                        </v-data-table>
                        </div>

                        <!-- <v-toolbar
                            flat
                            color="#faead8"
                            dense
                        >
                        
                        </v-toolbar> -->
                    </v-col>
                </v-row>

                </v-container>

            </v-form>
        </v-container>
    </div>
</template>

<script>

// import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    
    props: {
        parentObject: Object,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },

        data: {
            
            formData: {
                compnyname: this.$route.params.formData.compnyname,
                payoutcode: this.$route.params.formData.payoutcode,
            },

            parameters: {
                brchid: this.$route.params.param.branchid,
                deptid: this.$route.params.param.departmentid,
                emptypeid: this.$route.params.param.employmenttypeid,
                gradeid: this.$route.params.param.gradeid,
                staffid: this.$route.params.param.staffid,
            },
      },

            dataHeader: [
                {text: this.$t('columns.no'),                    width: '70px',  value: 'salhdid'},
                {text: this.$t('columns.company'),               width: '150px', value: 'compnycode'},
                {text: this.$t('columns.name'),                  width: '150px', value: 'psnname'},
                {text: this.$t('columns.staffid'),              width: '100px', value: 'staffcode'},
                {text: this.$t('previewpayroll.netpay'),               width: '100px', value: 'amount', align: 'end'},
                {text: 'RM 100',                width: '100px',  value: 'rm100', align: 'center'},
                {text: 'RM 50',                 width: '100px',  value: 'rm50', align: 'center'},
                {text: 'RM 20',                 width: '100px',  value: 'rm20', align: 'center'},
                {text: 'RM 10',                 width: '100px',  value: 'rm10', align: 'center'},
                {text: 'RM 5',                  width: '100px',  value: 'rm5', align: 'center'},
                {text: 'RM 1',                  width: '100px',  value: 'rm1', align: 'center'},
                {text: 'RM 0.50',               width: '100px',  value: 'sen50', align: 'center'},
                {text: 'RM 0.20',               width: '100px',  value: 'sen20', align: 'center'},
                {text: 'RM 0.10',               width: '100px',  value: 'sen10', align: 'center'},
                {text: 'RM 0.05',               width: '100px',  value: 'sen5', align: 'center'},
                {text: 'RM 0.01',               width: '100px',  value: 'sen1', align: 'center'},
            ],

            tableOpt: {
                itemsPerPage: -1
            },

            dataItems: [],

            dateYear: null,
            dateMonth: null,

            showID: false,
            showDate: false,

            total: this.$t('bankpaymentlistingreport.total'),
            totalCountRm100: 0,
            totalCountRm50: 0,
            totalCountRm20: 0,
            totalCountRm10: 0,
            totalCountRm5: 0,
            totalCountRm1: 0,

            totalCountSen50: 0,
            totalCountSen20: 0,
            totalCountSen10: 0,
            totalCountSen5: 0,
            totalCountSen1: 0,

            goBtn: false,
        };
    },

    methods: {

        backButton(){
            this.$router.push({name: 'parametercashdenomination'});
        },

        loadStaffCash() {

            this.goBtn = true;
            
            const vm = this;

            this.$store.dispatch('post', {
                url: `/postCashDenomination/${this.$store.getters.userId}`,  
                payload: this.data
            })
            .then(function (res) {
                
                vm.dataItems = res.data.rec;
          
                    vm.dateYear = vm.dataItems[0].poyr
                    vm.dateMonth = vm.dataItems[0].pomth
                    
                for (let i = 0; i < vm.dataItems.length; i++) {

                    vm.dataItems[i].salhdid = i + 1;

                    }

                    vm.cashDenom();
                    vm.cashDenomSen();
                    vm.format();
                    
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        cashDenom(){

            
            var value = [100, 50, 20, 10, 5, 1];  // the denomination you want to find.
            
            var count = 0, amount = 0

            const vm = this

            for (let i = 0; i < vm.dataItems.length; i++) {

                // vm.dataItems[i].amount is the netpay from salhd
                amount = vm.dataItems[i].amount
                
                
                for(var j = 0; j < value.length; j++){

                    count = amount/value[j]
                    
                    if(count >= 1){
                        
                        if(value[j] == 100){
                            
                            this.totalCountRm100 += Math.floor(count)
                            vm.dataItems[i].rm100 = Math.floor(count)
                            

                        } else if(value[j] == 50){

                            this.totalCountRm50 += Math.floor(count)
                            vm.dataItems[i].rm50 = Math.floor(count)

                        } else if(value[j] == 20){

                            this.totalCountRm20 += Math.floor(count)
                            vm.dataItems[i].rm20 = Math.floor(count)

                        } else if(value[j] == 10){

                            this.totalCountRm10 += Math.floor(count)
                            vm.dataItems[i].rm10 = Math.floor(count)

                        } else if(value[j] == 5){

                            this.totalCountRm5 += Math.floor(count)
                            vm.dataItems[i].rm5 = Math.floor(count)
                            
                        } else{

                            this.totalCountRm1 += Math.floor(count)
                            vm.dataItems[i].rm1 = Math.floor(count)

                            }
                    }

                    amount = count * value[j]
                    amount = amount % value[j]

                }
                    
                }

        },

        cashDenomSen(){

            var value = [50, 20, 10, 5, 1];  // the denomination you want to find.
            
            var count = 0, amount = 0;

            const vm = this

            for (let i = 0; i < vm.dataItems.length; i++) {

                // vm.dataItems[i].amount is the netpay from salhd
                amount = vm.dataItems[i].amount - Math.floor(vm.dataItems[i].amount)
                amount = parseFloat(amount.toFixed(2))
                amount = amount * 100

                for(var j = 0; j < value.length; j++){

                    count = amount/value[j]
                    
                    if(count >= 1){
                        
                        if(value[j] == 50){
                            
                            this.totalCountSen50 += Math.floor(count)
                            vm.dataItems[i].sen50 = Math.floor(count)

                        } else if(value[j] == 20){

                            this.totalCountSen20 += Math.floor(count)
                            vm.dataItems[i].sen20 = Math.floor(count)

                        } else if(value[j] == 10){

                            this.totalCountSen10 += Math.floor(count)
                            vm.dataItems[i].sen10 = Math.floor(count)

                        } else if(value[j] == 5){

                            this.totalCountSen5 += Math.floor(count)
                            vm.dataItems[i].sen5 = Math.floor(count)

                        } else{

                            this.totalCountSen1 += Math.floor(count)
                            vm.dataItems[i].sen1 = Math.floor(count)

                        }
                    }

                    amount = count * value[j]
                    amount = amount % value[j]

                }
                    
                }

                

        },

        printPDF() {

            const doc = new jsPDF({
                orientation: 'landscape'
            })

            var head = [
                { title: this.$t('columns.no'),                      dataKey: 'salhdid' },
                { title: this.$t('columns.company'),                 dataKey: 'compnycode' },
                { title: this.$t('columns.name'),                    dataKey: 'psnname' },
                { title: this.$t('columns.staffid'),              dataKey: 'staffcode' },
                { title: this.$t('previewpayroll.netpay'),                 dataKey: 'amount' },
                { title: 'RM 100',                  dataKey: 'rm100' },
                { title: 'RM 50',                   dataKey: 'rm50' },
                { title: 'RM 20',                   dataKey: 'rm20' },
                { title: 'RM 10',                   dataKey: 'rm10' },
                { title: 'RM 5',                    dataKey: 'rm5' },
                { title: 'RM 1',                    dataKey: 'rm1' },
                { title: 'RM 0.50',                 dataKey: 'sen50' },
                { title: 'RM 0.20',                 dataKey: 'sen20' },
                { title: 'RM 0.10',                 dataKey: 'sen10' },
                { title: 'RM 0.5',                  dataKey: 'sen5' },
                { title: 'RM 0.1',                  dataKey: 'sen1' }
            ]

            let body = []

            for (var i = 0; i < this.dataItems.length; i++) {

                body.push({
                    salhdid : this.dataItems[i].salhdid,
                    compnycode : this.dataItems[i].compnycode,
                    psnname : this.dataItems[i].psnname,
                    staffcode : this.dataItems[i].staffcode,
                    amount : this.dataItems[i].amount,
                    rm100 : this.dataItems[i].rm100,
                    rm50 : this.dataItems[i].rm50,
                    rm20 : this.dataItems[i].rm20,
                    rm10 : this.dataItems[i].rm10,
                    rm5 : this.dataItems[i].rm5,
                    rm1 : this.dataItems[i].rm1,
                    sen50: this.dataItems[i].sen50,
                    sen20: this.dataItems[i].sen20,
                    sen10: this.dataItems[i].sen10,
                    sen5: this.dataItems[i].sen5,
                    sen1: this.dataItems[i].sen1,
                })

            }

            body.push({
                    amount: "Total",
                    rm100 : this.totalCountRm100,
                    rm50 : this.totalCountRm50,
                    rm20 : this.totalCountRm20,
                    rm10 : this.totalCountRm10,
                    rm5 : this.totalCountRm5,
                    rm1 : this.totalCountRm1,
                    sen50 : this.totalCountSen50,
                    sen20 : this.totalCountSen20,
                    sen10 : this.totalCountSen10,
                    sen5 : this.totalCountSen5,
                    sen1 : this.totalCountSen1,
                })
            
            doc.text(this.$t('cashdenominationlistingreport.cashdenominationlisting'), 10, 10)
            
            // if(this.formData.payoutcode){
            //     doc.text('Payout ID', 74, 10)
            //     doc.text(this.formData.payoutcode.toString(), 100, 10)
            // } else {

            //     doc.text('Payout Year', 74, 10)
            //     doc.text(this.formData.pyyear.toString(), 107 , 10)
            //     doc.text('Payout Month', 122, 10)
            //     doc.text(this.formData.pymonth.toString(), 158, 10)
            // }

            doc.autoTable(head, body)
            doc.save('Cash Denomination Listing.pdf')
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', 'Cash Denomination.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.dataItems
            let data = []


            for (var i = 0; i < item.length; i++) {

                data.push({
                    [`${this.$t('columns.no')}`]: item[i].salhdid,
                    [`${this.$t('columns.company')}`]: item[i].compnycode,
                    [`${this.$t('columns.name')}`]: item[i].psnname,
                    [`${this.$t('columns.staffid')}`]: item[i].staffcode,
                    [`${this.$t('previewpayroll.netpay')}`]: item[i].amount,
                    'RM 100': item[i].rm100,
                    'RM 50': item[i].rm50,
                    'RM 20': item[i].rm20,
                    'RM 10': item[i].rm10,
                    'RM 5': item[i].rm5,
                    'RM 1': item[i].rm1,
                    'RM 0.50': item[i].sen50,
                    'RM 0.20': item[i].sen20,
                    'RM 0.10': item[i].sen10,
                    'RM 0.05': item[i].sen5,
                    'RM 0.01': item[i].sen1
                })
            }

            data.push({
                    [`${this.$t('columns.no')}`]: '',
                    [`${this.$t('columns.company')}`]: '',
                    [`${this.$t('columns.name')}`]: '',
                    [`${this.$t('columns.staffid')}`]: '',
                    [`${this.$t('previewpayroll.netpay')}`]: 'Total',
                    'RM 100': this.totalCountRm100,
                    'RM 50': this.totalCountSen50,
                    'RM 20': this.totalCountRm20,
                    'RM 10': this.totalCountRm10,
                    'RM 5': this.totalCountRm10,
                    'RM 1': this.totalCountRm1,

                    'RM 0.50': this.totalCountSen50,
                    'RM 0.20': this.totalCountSen20,
                    'RM 0.10': this.totalCountSen10,
                    'RM 0.05': this.totalCountSen5,
                    'RM 0.01': this.totalCountSen1,
                })

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        format() {
            console.log("Format",this.dataItems.length)
            for (let i = 0; i < this.dataItems.length; i++) {
                if (this.dataItems[i].amount !== null) {
                    let getSubTotalPos = this.dataItems[i].amount.toFixed(2);
                    this.dataItems[i].amount = this.CommaFormatted(getSubTotalPos);
                }
            }
        },

        CommaFormatted(amount) {
            var delimiter = ","; // replace comma if desired
            var a = amount.split('.',2)
            var d = a[1];
            var i = parseInt(a[0]);
            if(isNaN(i)) { return ''; }
            var minus = '';
            if(i < 0) { minus = '-'; }
            i = Math.abs(i);
            var n = new String(i);
            var b = [];
            while(n.length > 3) {
                var nn = n.substr(n.length-3);
                b.unshift(nn);
                n = n.substr(0,n.length-3);
            }
            if(n.length > 0) { b.unshift(n); }
            n = b.join(delimiter);
            if(d.length < 1) { amount = n; }
            else { amount = n + '.' + d; }
            amount = minus + amount;
            return amount;
        },

    },

    

    mounted() {
        
    },

    created(){
        const vm = this;
        vm.formData = this.$route.params.formData;
        console.log("formdata received" , vm.formData)

        if(vm.formData.payoutcode){
            this.showID = true;
        } else {
            this.showDate = true;
        }

        this.loadStaffCash();       
        
    }
    
}
</script>

<style>

.dateTitle {
    font-size: 12px;
    color:#FFFFFF;
    height: 0px;
    background-color: orange;
    align-content: center;
    justify-content: center;
}

.scroller {
  height: 100%;
}

.total {
    background-color: #FFF3E0;
}

.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }


/* ── Table horizontal scroll fix ── */
.rpt-table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 8px 8px 0 0;
  border: 1px solid #E8EDF5;
}
.rpt-table-wrap .v-data-table__wrapper {
  overflow-x: visible !important;
}
.rpt-table-wrap .v-data-footer {
  position: sticky;
  left: 0;
  background: #fff;
  border-top: 1px solid #E8EDF5;
  min-width: unset !important;
}


/* ── Total bar ── */
.total-bar {
  width: 100%;
  background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%);
  border-radius: 0 0 8px 8px;
  border: 1px solid #C7D2FE;
  border-top: none;
  padding: 12px 20px;
}
.total-bar-inner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}
.total-label {
  font-size: 0.88rem;
  font-weight: 700;
  color: rgba(255,255,255,0.85);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.total-amount {
  font-size: 1.1rem;
  font-weight: 800;
  color: #ffffff;
  background: rgba(255,255,255,0.15);
  padding: 4px 16px;
  border-radius: 20px;
  min-width: 120px;
  text-align: right;
  border: 1px solid rgba(255,255,255,0.25);
}
</style>